export const SGB_PRODUCT_DETAILS = "SGB_PRODUCT_DETAILS";
export const SGB_PRODUCT_ERROR = "SGB_PRODUCT_ERROR";
export const SGB_PRODUCT_HIDE_ERROR = "SGB_PRODUCT_HIDE_ERROR";
export const SGB_PRODUCT_START_LOADER = "SGB_PRODUCT_START_LOADER";
export const SGB_PRODUCT_STOP_LOADER = "SGB_PRODUCT_STOP_LOADER";
